import React from 'react';
import { Box, Button, Typography } from '@mui/material';

const CustomPagination = ({ page, setPage, totalData, itemsPerPage }) => {
    const totalPages = Math.ceil(totalData / itemsPerPage) || 1;    
    const handlePreviousPage = () => setPage((prev) => Math.max(prev - 1, 0));
    const handleNextPage = () => setPage((prev) => Math.min(prev + 1, totalPages - 1));
    const getPageNumbers = () => {
        const pages = [];
        for (let i = 0; i < totalPages; i++) {
            pages.push(i);
        }
        return pages;
    };
   
    const safeTotalData = totalData || 0;
    const safeItemsPerPage = itemsPerPage || 1; // Prevent division by 0
    const totalShown = itemsPerPage >=totalData? totalData: Math.min((page + 1) * safeItemsPerPage, safeTotalData);
    
    // Calculate the total number of elements displayed up to the current page
    // const totalShown = Math.min((page + 1) * itemsPerPage, totalData);

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: 2,
                direction: "rtl"
            }}
        >

            {/* Pagination Controls on the Left */}
            <Box sx={{ display: 'flex', alignItems: 'center', direction: "ltr" }}>
                <Box
                    onClick={handlePreviousPage}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        padding: '0 8px',

                    }}
                    disabled={page === 0}
                >
                    <div

                        style={{
                            color: '#C49A6C',
                            cursor: 'pointer',
                            opacity: page === 0 ? 0.5 : 1, // Reduce opacity when disabled
                        }}
                    >
                        &lt; {/* Previous Single Arrow */}
                    </div>
                    <div

                        style={{
                            color: '#12538B',
                            cursor: 'pointer',

                            opacity: page === totalPages - 1 ? 0.5 : 1, // Reduce opacity when disabled
                        }}
                    >
                        &lt; {/* Next Single Arrow */}
                    </div>
                </Box>
                {/* Previous Arrows */}



                {/* Page Numbers */}
                {getPageNumbers().map((pg) => (
                    <Button
                        key={pg}
                        onClick={() => setPage(pg)}
                        sx={{
                            backgroundColor: pg === page ? '#C49A6C' : 'transparent',
                            color: pg === page ? '#fff' : '#12538B',
                            fontWeight: pg === page ? 'bold' : 'normal',
                            minWidth: '30px',
                            height: '30px',
                            flexDirection: "row-reverse"
                        }}
                    >
                        {pg + 1}
                    </Button>
                ))}

                {/* Next Arrows */}
                <Box
                    onClick={handleNextPage} // Move 2 pages forward on clicking the Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        padding: '0 8px',


                    }}
                >
                    <div
                        style={{
                            color: '#12538B',
                            padding: 0,
                            minWidth: 'auto',
                            opacity: page >= totalPages - 2 ? 0.5 : 1, 
                        }}
                        disabled={page >= totalPages - 2} // Disable if at the last or second-to-last page
                    >
                        &gt; {/* Next Single Arrow */}
                    </div>
                    <div
                       style={{
                            color: '#C49A6C',
                            padding: 0,
                            minWidth: 'auto',
                            opacity: page >= totalPages - 2 ? 0.5 : 1, 
                        }}
                        disabled={page >= totalPages - 2} // Disable if at the last or second-to-last page
                    >
                        &gt;
                    </div>
                </Box>

            </Box>

            {/* "Showing X from Y elements" Text on the Right */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <Typography sx={{ color: '#3E4954', fontSize: '14px' }}>
                Showing {totalShown} from {safeTotalData} data
                </Typography>
            </Box>
        </Box>
    );
};

export default CustomPagination;
